import { mapGetters } from 'vuex'
import {EventBus} from "@/utils/event-bus";
import moment from 'moment';
const base={
  data(){
    let homePageView = [709,710,711,712]
    let assetView=[182,2,115,282,456,575];  //资产呈现
    let assetInsert=[5,117,3,116,244,459,460];  //资产录入
    let assetReport=[23]; //资产报表
    let assetReportIt=[403] //资产报失
    let assetDeletion=[548] //资产删除记录
    let operateOverview=[318]; // 租赁运营概况；
    let operateOrder=[75,76,229,230,371,419,480]; //订单管理；
    let operateBusiness=[11,10,196,262,14,242,411,493,528,611]; //业务管理；
    let operatePrice=[12,428,364,473]; //定价管理；
    let operateCustomer=[73,236,74,249,617,636,631]; //客户管理；
    let operateFinance=[19,276,101,255,398,488,377,424,502,534,654,655,656,701]; //财务管理；
    let merchantManagement = [678,679,680,695,733];//换电商家管理
    let operateReport=[69]; //运营报表；
    let changeOperatorView=[544];//换电运营报表
    let carOperatorView=[669];//换电运营报表
    let bordereaux=[795]  //业务报表
    let serviceChargebill=[521]; //服务费账单
    let omlineBulletion=[537]; //线上公告
    let shortMessageNumber = [648];//短信发送量统计菜单
    let electrovalenceManagement =[721];//电价管理
    let marketingActivities=[336,512,561,567,728]; //营销活动
    let remoteUpgrade=[621,622]; // 远程升级
    let apiInterface = [448]; //API接口服务
    let onlineMonitoring=[16,172,224,17,440,515,672,704];  //线上监控
    let offlineAftersale=[205,207,299,321,453,549,576,713,718]; //线下售后
    let personManager=[206,208,554]; //人员管理
    let aftersaleReport=[24]; //售后报表

    let accountManager=[26];
    let roleManager=[27];
    let DataDictionary=[28];
    let accountLevel =[353];
    let personnelManagement = [384];//生产人员管理
    let taskManagement = [385];//生产任务管理
    let productionTesting=[443]//生产检测
    let permissionGroup={
          homePage:{homePageView},
          assetManager:{
            assetView,assetInsert,assetReport,assetReportIt,assetDeletion
          },
          operateManager:{

             operateOverview,operateOrder,operateBusiness,operatePrice,operateCustomer,operateFinance,operateReport,marketingActivities,remoteUpgrade,apiInterface,serviceChargebill,changeOperatorView,omlineBulletion,shortMessageNumber
             ,carOperatorView,merchantManagement,electrovalenceManagement,bordereaux


          },
          aftersaleManager:{
            onlineMonitoring,offlineAftersale,personManager,aftersaleReport
          },
          systemSettings:{
            accountManager,roleManager,DataDictionary,accountLevel
          },
          productionManagement:{
            personnelManagement,taskManagement,productionTesting
          }
    }
    return {screenWidth: 0,permissionGroup}
  },
  computed: {
    ...mapGetters([
      'theme',
    ]),
    calcFontSize() {
      return function (value, min) {
        let size = (value / 1920 * this.screenWidth);
        if (min) {
          if (size < min) {
            size = min;
          }
        }
        return size + 'px';
      }

    },
  },
  mounted() {
    this.handleReSize = (e) => {
      this.screenWidth = document.body.clientWidth;
    }
    window.addEventListener('resize', this.handleReSize);
    this.handleReSize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleReSize)
  },
  beforeRouteEnter(to, form, next) {
    EventBus.$emit("startPage",to);
    next()
    EventBus.$emit("startPage2",to);
  },
  beforeRouteLeave(to, form, next) {
    // let formList= localStorage.getItem("form");
    // if(!formList){
    //   formList=[]
    // }else{
    //   formList=JSON.parse(formList)
    // }
    // formList.push({name:form.name});
    // localStorage.setItem("form",JSON.stringify(formList));
    EventBus.$emit("endPage",form);
    next()

  },
  methods:{
    formatTime(time){
      return  moment(new Date(time)).format('YYYY-MM-DD HH:mm:ss');
    },
    hasPermission(id) {
      return this.$store.getters.hasPermission(id);
    },
    hasPermissionGroup(ids) {
      for(var i=0;i<ids.length;i++){
        if( this.$store.getters.hasPermission(ids[i])){
          return true;
        }
      }
      return false;

      ;
    },
    getPageInfo({label,name,last}){
      return {page:this.$route.name,label:label,last,name:name,route:this.$route,that:this}
    },
    //列控制
    isShowColumn(table,field) {
      return this.$store.getters.isShowColumn(table,field);
    },
    loadImage(path){
      if(this.theme=="theme1"){
              return require("@/assets/theme1"+path);
      }
      if(this.theme=="theme2"){
        return require("@/assets/theme2"+path);
      }
      if(this.theme=="theme2_skyblue"){
        return require("@/assets/theme2"+path);
      }
    },
    // 用于新增或者编辑页面之后跳转页面，也会刷新编辑和新增页面
    closeCurrentPageAndJumpToPage(params){
      this.$store.dispatch("tagsView/delView", Object.assign({}, this.$route))
        .then(({ visitedViews }) => {
          if(params){
            this.$router.push(params);
          }

        });
    },
    // 用于跳转页面缓存问题。例如跳转到监控页面
    toCachePage(params){
      if(!params){
        return;
      }
      let find=false;
      let visitedViews= this.$store.state.tagsView.visitedViews;
      if(visitedViews){
        for (let i = 0; i < visitedViews.length; i++) {
          let view=visitedViews[i];


               if( view.name==params.name || view.path==params.path){
                  find=true;
                  this.$store
                    .dispatch("tagsView/delView",  Object.assign({}, view))
                    .then(({ visitedViews }) => {

                      this.$router.push(params);
                    });

                }

        }
      }
      if(!find){
        this.$router.push(params);
      }

      console.log(visitedViews);
    },

    isShowCol(field) {
      let sd= this.colData.filter((item)=>{return item.field===field})
      return sd[0].istrue

    },

  }
}
export default base;



// WEBPACK FOOTER //
// ./src/components/Mixin/base.js